import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import SubRegionForm from '../containers/SubRegionFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class SubRegionEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `SubRegionEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('subregion_route_edit')} />
          <SubRegionForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default SubRegionEditScreen;

Logger.log('silly', `SubRegionEditScreen loaded.`);
